export const state = {
  // product: undefined,
  // products: []
  role: {},
  roles: [],
  pagination:''
}
